// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/assets/css/theme.less'
import '@/assets/css/test.less'
import '@/assets/css/eig.less'
import '@/assets/css/index-s_XQL9wA.css'
// import '@/assets/css/font-awesome.css'
import '@/assets/css/font-ping.css'
import 'swiper/css/swiper.css'
import 'animate.css';


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import less from 'less'




Vue.config.productionTip = false
// Vue.use(less)
Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js